import React, { Component } from 'react';
import { Typography, Image } from 'antd';
import { StoreContext } from "../store/RootStore";

const { Title } = Typography;

class VehicleStatusSummary extends Component {
  static contextType = StoreContext; // Replace with actual context if used



  renderStatusCircle(backgroundClass, labelKey, value, statusKey) {
    const wrapperClass = this.props.wrapperClassName || "details-circle";
    const wrapperClassInner = this.props.wrapperClassInner || "detail-innercircle";
    const showImage = this.props.showImage !== false; // default is true


    return (
      <div className={`${wrapperClass} login-circle`}
        onClick={() => this.props.onStatusClick?.(statusKey)}
        style={{ cursor: this.props.onStatusClick ? "pointer" : "default" }}
      >
        <div className={`${wrapperClassInner} ${backgroundClass}`}>
          {showImage && (
            <Image
              src={require('../assets/images/st-car.png')}
              alt="SecurePath"
              preview={false}
              className="circle-logo"
              height="38px"
            />
          )}
          <div className="text-center">
            <Title level={5} className="white-text m-0" style={{ fontSize: '0.75rem', color: 'white' }}>
              {this.context.translate(labelKey)}
            </Title>
            <span style={{ color: '#FFF', fontSize: '0.75rem' }}>
              {value}
            </span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { statusData, total } = this.props;
    return (
      <div className="status-summary-container d-flex gap-3">
        {this.renderStatusCircle('redackground', '_STOPPED_', statusData?.Stopped, "Stop")}
        {this.renderStatusCircle('turquoisebackground', '_RUNNING_', statusData?.Moving, "Running")}
        {this.renderStatusCircle('yellowbackground', '_IDLE_', statusData?.Idle, "Idle")}

        {this.props.showPowerCut !== false &&
          this.renderStatusCircle('lgreybackground', '_POWER_CUT_', statusData?.PowerCut, "powerCut")}

        {this.renderStatusCircle('dbluebackground', '_NoData_', statusData?.NoData, "NoData")}
        {this.renderStatusCircle('dpurplebackground', '_NON_REPORT_', statusData?.vehNonReportingCountResult, "notReport")}

        {this.renderStatusCircle('dgreybackground', '_ALL_', statusData?.actualtotalvehstate, "normal")}

        {this.props.showGeofence !== false &&
          this.renderStatusCircle('lgreybackground', '_GEOFENCE_', statusData?.geofence, "geofence")}
      </div>
    );
  }
}

export default VehicleStatusSummary;
